import { render } from "./TipoIden_Persona.vue?vue&type=template&id=57baaa3a"
import script from "./TipoIden_Persona.vue?vue&type=script&lang=js"
export * from "./TipoIden_Persona.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__